import React, { useRef } from 'react';
import useTooltip from 'shared/lib/useTooltip';
import DoubleClickTooltip from 'fantastic/components/common/DoubleClickTooltip';

const Item = ({ data: { kind } }) => {
  const [triggerRef, tooltip] = useTooltip(<DoubleClickTooltip />);

  return (
    <>
      {tooltip}
      <div className={`fantastic-tool fantastic-tool__${kind}`} ref={triggerRef}>
        {kind === 'image' ? (
          <div className="fantastic-tool__image--icon" />
        ) : (
          <>
            <i className={`fi fi-${kind}`} />
            {kind === 'button' && <label>{i18n.t('button')}</label>}
          </>
        )}
      </div>
    </>
  );
};

export default Item;
